import { API_BASE_URL, CATEGORY_BASE_URL, STIP_BASE_URL } from "../props";
import { useSelector } from "react-redux";
import { useQuery } from "react-query";
import { doGet, useGet } from "../common/fetchServices";

const BISAC_URL = `${CATEGORY_BASE_URL}/bisacs`;
const CONTRIBUTOR_ROLES_URL = `${API_BASE_URL}/vocabularies/contributor-roles`;
// const CONTRIBUTOR_TYPES_URL = `${API_BASE_URL}/vocabularies/contributor-types`;
const LANGUAGES_URL = `${API_BASE_URL}/vocabularies/languages`;
const LICENSE_TYPES_URL = `${API_BASE_URL}/vocabularies/license-types`;
const AUDIO_TYPES_URL = `${STIP_BASE_URL}/audio-types`;
const IMAGE_MEDIUM_FORMATS_URL = `${STIP_BASE_URL}/medium-formats/image`;
const OD_MEDIUM_FORMATS_URL = `${STIP_BASE_URL}/medium-formats/other-document`;
const AUDIENCES_URL = `${STIP_BASE_URL}/audiences`;
const AGE_RANGES_URL = `${STIP_BASE_URL}/age-ranges`;
const PRODUCT_IDENTIFIERS_URL = `${API_BASE_URL}/vocabularies/product-identifiers`;

const useFetchQuery = (key, url) => {
  const auth = useSelector(state => state.auth);
  return useQuery(
    [key],
    () => {
      return doGet(auth)(url);
    },
    {
      staleTime: Infinity,
    },
  );
};

export const useLanguages = () => {
  return useFetchQuery("languages", LANGUAGES_URL);
};

export const useLicenseTypes = () => {
  return useFetchQuery("license-type", LICENSE_TYPES_URL);
};

export const useCategories = () => {
  return useFetchQuery("categories", BISAC_URL);
};

export const useAudioTypes = () => {
  return useFetchQuery("audio-types", AUDIO_TYPES_URL);
};

export const useAudiences = () => {
  return useFetchQuery("audiences", AUDIENCES_URL);
};

export const useImageMediumFormats = () => {
  return useFetchQuery("image-medium-formats", IMAGE_MEDIUM_FORMATS_URL);
};

export const useDocumentMediumFormats = () => {
  return useFetchQuery("document-medium-formats", OD_MEDIUM_FORMATS_URL);
};

export const useContributorRoles = () => {
  return useFetchQuery("contributor-roles", CONTRIBUTOR_ROLES_URL);
};

export const useAgeRanges = () => {
  return useFetchQuery("age-ranges", AGE_RANGES_URL);
};

export const useProductIdentifiers = () => {
  return useGet(["product-identifiers"], PRODUCT_IDENTIFIERS_URL);
};
